<template>
    <div class="q-pa-md">
        <div class="column q-col-gutter-md">
            <div class="col">
                <!-- <q-input
                    v-model.trim="user.email"
                    :label="$t('general.email')"
                    outlined
                    clearable
                    counter
                    maxlength="250"
                    type="email"
                    bg-color="white"
                    :error-message="emailErrors"
                    :error="emailErrors != ''"
                    @input="$v.user.email.$touch()"
                    @blur="$v.user.email.$touch()"
                /> -->
                <p>
                    <span class="text-bold">{{ $t('general.email') }}:</span>
                    {{ user.email }}
                </p>
            </div>
            <div class="col self-start">
                <q-toggle
                    v-model="changePassword"
                    :label="$t('actions.change_password')"
                    left-label
                    color="secondary"
                    keep-color
                    size="lg"
                    @input="setPasswordsValidationState"
                />
            </div>
            <div v-if="changePassword" class="column q-col-gutter-md">
                <div class="col">
                    <q-input
                        v-model="user.currentPassword"
                        :label="$t('general.current_password')"
                        outlined
                        :type="isCurrentPassword ? 'password' : 'text'"
                        bg-color="white"
                        :error-message="passwordErrors"
                        :error="passwordErrors != ''"
                        @input="$v.user.currentPassword.$touch()"
                        @blur="$v.user.currentPassword.$touch()"
                    >
                        <template v-slot:append>
                            <q-icon
                                :name="
                                    isCurrentPassword
                                        ? 'visibility_off'
                                        : 'visibility'
                                "
                                class="cursor-pointer"
                                @click="isCurrentPassword = !isCurrentPassword"
                            />
                        </template>
                    </q-input>
                </div>
                <div class="col">
                    <q-input
                        v-model="user.newPassword"
                        :label="$t('general.new_password')"
                        outlined
                        :type="isNewPassword ? 'password' : 'text'"
                        bg-color="white"
                        :error-message="newPasswordErrors"
                        :error="newPasswordErrors != ''"
                        @input="$v.user.newPassword.$touch()"
                        @blur="$v.user.newPassword.$touch()"
                    >
                        <template v-slot:append>
                            <q-icon
                                :name="
                                    isNewPassword
                                        ? 'visibility_off'
                                        : 'visibility'
                                "
                                class="cursor-pointer"
                                @click="isNewPassword = !isNewPassword"
                            />
                        </template>
                    </q-input>
                </div>
                <div class="col">
                    <q-input
                        v-model="user.confirmPassword"
                        :label="$t('general.password_confirm')"
                        outlined
                        :type="isConfirmPassword ? 'password' : 'text'"
                        bg-color="white"
                        :error-message="passwordConfirmErrors"
                        :error="passwordConfirmErrors != ''"
                        @input="$v.user.confirmPassword.$touch()"
                        @blur="$v.user.confirmPassword.$touch()"
                    >
                        <template v-slot:append>
                            <q-icon
                                :name="
                                    isConfirmPassword
                                        ? 'visibility_off'
                                        : 'visibility'
                                "
                                class="cursor-pointer"
                                @click="isConfirmPassword = !isConfirmPassword"
                            />
                        </template>
                    </q-input>
                </div>
            </div>
            <div class="col self-end">
                <q-btn
                    color="secondary"
                    :label="$t('actions.save')"
                    @click="savePersonnalData"
                />
            </div>
        </div>
    </div>
</template>

<script>
import validations from '@/views/profile/my-account/mixins/validations'
import usersService from '@/services/modules/users'
import notify from '@/local-shared/mixins/notify'
import store from '@/store'

const loadingKeys = {
    savingData: 'saving-data',
}

export default {
    name: 'MyAccount',

    components: {},

    mixins: [validations, notify],

    data() {
        return {
            isCurrentPassword: true,
            isNewPassword: true,
            isConfirmPassword: true,

            changePassword: false,

            user: {
                email: '',
                currentPassword: '',
                newPassword: '',
                confirmPassword: '',
            },
        }
    },

    computed: {
        storedUser() {
            return store.getters['session/user']
        },

        isSaving() {
            return this.isSavingData
        },

        isSavingData() {
            return !!this.loadings.filter(
                (loading) => loading.key === loadingKeys.savingData
            ).length
        },
    },

    async created() {
        this.user.email = this.storedUser.email
        this.setPasswordsValidationState()
    },

    methods: {
        setPasswordsValidationState() {
            if (!this.changePassword) {
                this.$v.user.currentPassword.$reset()
                this.$v.user.newPassword.$reset()
                this.$v.user.confirmPassword.$reset()
                this.user.newPassword = ''
                this.user.confirmPassword = ''
            }
        },

        async savePersonnalData() {
            this.$v.user.email.$touch()

            if (this.changePassword) {
                this.$v.user.currentPassword.$touch()
                this.$v.user.newPassword.$touch()
                this.$v.user.confirmPassword.$touch()
            }

            if (this.$v.$invalid || this.isSaving) {
                return true
            }

            this.loadingAdd(loadingKeys.savingData)

            let parameters = {
                data: [
                    {
                        id: this.storedUser.id,
                        email: this.user.email,
                        current_password: this.user.currentPassword,
                        new_password: this.user.newPassword,
                        updatePassword: this.changePassword,
                    },
                ],
            }

            let response = await usersService.update(parameters)

            if (response.status === 200) {
                this.$q.notify({
                    type: 'positive',
                    message: this.$t('notify.profile_updated'),
                })
                //TODO: store.dispatch('session/setUser', { ...this.user })
            } else {
                this.$q.notify({
                    type: 'negative',
                    message: this.$t('notify.error_occurred', {
                        message: response.data.message,
                    }),
                })
            }

            this.loadingRemove(loadingKeys.savingData)
        },
    },
}
</script>
